export default "__VITE_ASSET__f781ae02__"